import { render, staticRenderFns } from "./IntegrationHour.vue?vue&type=template&id=53f506b7"
import script from "./IntegrationHour.vue?vue&type=script&lang=js"
export * from "./IntegrationHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f506b7')) {
      api.createRecord('53f506b7', component.options)
    } else {
      api.reload('53f506b7', component.options)
    }
    module.hot.accept("./IntegrationHour.vue?vue&type=template&id=53f506b7", function () {
      api.rerender('53f506b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/IntegrationHour.vue"
export default component.exports